<template>
    <page>
        <module>
            <view-list ref="view"  :work-type="workType" selector :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="采购单号">
                            <c-input name="purchase_code"></c-input>
                        </m-search-item>
                        <m-search-item label="快递单号">
                            <c-input name="express_no"></c-input>
                        </m-search-item>
                        <m-search-item label="售卖人信息">
                            <c-input name="seller_info"></c-input>
                        </m-search-item>
                        <m-search-item label="仓库">
                            <c-select name="store_id" async @search="searchStore"></c-select>
                        </m-search-item>
                        <m-search-item label="创建时间">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_online_purchase_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <!--多选后操作栏切换为批量模式：显示已选条数并可取消勾选，按钮与常态操作栏保持一致-->
                <template #batchOperate>
                    <c-button v-if="auth('b_online_purchase_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <!--采购单状态-->
                <template #purchase_state="{data}">
                    <c-state tag async dict="PURCHASE_ORDER_STATE" :value="data.purchase_state"></c-state>
                </template>
                <!--采购单类型-->
                <template #purchase_type="{data}">
                    <c-state tag async dict="PURCHASE_ORDER_TYPE" :value="data.purchase_type"></c-state>
                </template>
                <!--采购渠道-->
                <template #purchase_channel="{data}">
                    <c-state tag async dict="PURCHASE_CHANNEL" :value="data.purchase_channel"></c-state>
                </template>
                <!--采购总价-->
                <template #purchase_money="{data}">
                    ￥{{data.purchase_money}}
                </template>
                <!--统计数据-->
                <template #statistic_data="{data}">
                    收 {{data.purchase_product_count}}
                    验 {{data.checked_count}}
                    退 {{data.return_count}}
                </template>
                <!--售卖人信息-->
                <template #seller_info="{data}">
                    <div class="m-product-info">
                        <p>售卖人：{{data.seller_name|| '-'}}</p>
                        <p>手机号：{{data.seller_phone|| '-'}}</p>
                        <p>地址：{{data.seller_address|| '-'}}</p>
                    </div>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="180"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="openDetail(data)">查看</c-table-button>
                        <c-table-button v-if="auth('b_online_purchase_order_receive') && data.purchase_state == 1" icon="tf-accept" @click="receipt(data)">确认收货</c-table-button>
                        <c-table-button v-if="auth('b_online_purchase_order_edit')" icon="tf-edit" @click="editPurchaseOrder(2,data)" :disabled="data.purchase_state == 1 || data.purchase_state >= 4">编辑</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'

export default {
    components: {
    },

    computed: {
        ...mapState(['saasInfo','userInfo'])
    },

    data() {
        return {
            workType:3,
            supplierId:0
        }
    },

    methods: {
        /*******搜索【质检仓库】下拉框信息*****************/
        searchStore(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'STORE',
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /**
         * 查看采购单详情，弹窗内初检完成后刷新列表
         */
        openDetail(data) {
            this.globalDialog('purchaseDetail', {
                props: {id: data.id}
            }, () => {
                //刷新页面
                this.$refs.view.update();
            });
        },
        /**
         * 编辑线购单
         * @param operation_type    操作类型 1=确认收货 2=编辑
         * @param data              采购单数据
         */
        editPurchaseOrder(operation_type,data) {
            this.globalDialog('onlinePurchaseEdit', {
                props: {
                    operation_type: operation_type
                },
                data:data
            }, () => {
                //刷新页面
                this.$refs.view.update();
            });
        },
        /**
         * 确认收货
         */
        receipt(data) {
            this.$confirm({
                message:'是否确认采购单【' + data.purchase_code + '】已收到货品？确认后，采购单状态将变更为“质检中”，允许编辑采购单并录入商品信息',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/online/purchase/order/receipt',
                        data: {
                            purchase_order_id: data.id,
                        },
                        loading: true,
                        success: data => {
                            //刷新列表
                            this.$refs.view.update();
                            this.$message({
                                message: '确认收货成功',  // 提示内容,
                                type: 'success'
                            });
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.m-product-info {
    line-height: 24px;
    font-size: 13px;
    color: #333;

    .m-product-info-name {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .m-product-info-code {
        color: #999;
        font-size: 12px;
    }
}
</style>